import React, { Component } from 'react';

import { ERROR } from 'constants/error-severities';
import { ENTER } from 'constants/keyCodes';

import inputErrorSrc from 'img/input-error.svg';

import './styles.less';

const noop = function () {};

export default class Input extends Component {
  static defaultProps = {
    autoFocus: false,
    readOnly: false,
    isRequired: false,
    fieldType: 'text',
    fieldLabel: null,
    inputClass: '',
    spellCheck: false,
    fieldValue: '',
    status: null, // error/success message
    severity: '', // "error" or "success"
    onChange: noop, // handle update to the value of the input field
    onFocus: noop,
    onBlur: noop,
  };

  constructor(props) {
    super(props);

    this.onKeyUp = this.onKeyUp.bind(this);
  }

  render() {
    const {
      autoFocus,
      disabled,
      readOnly,
      isRequired,
      fieldId,
      fieldType,
      fieldLabel,
      inputClass,
      spellCheck,
      fieldValue,
      status,
      severity,
      onChange,
      onFocus,
      onBlur,
      onKeyDown,
    } = this.props;

    const isReadonly = readOnly ? 'is-readonly' : '';
    const hasLabel = fieldLabel ? 'has-label' : '';

    const asterix = isRequired ? <sup>*</sup> : '';
    const label = (
      <label htmlFor={fieldId}>
        {fieldLabel}
        {asterix}
      </label>
    );

    // Make sure that input value is never null to prevent console warning
    const inputFieldValue = fieldValue ? fieldValue : '';

    return (
      // "label" and "required" are needed to make the floating labels work
      // see: http://www.cssscript.com/pure-css-material-design-floating-input-placeholder
      <div className={`loom-input ${inputClass}`}>
        <div className="loom-input-container">
          <input
            id={fieldId}
            autoFocus={autoFocus}
            className={`${isReadonly} ${hasLabel} ${severity}`}
            readOnly={readOnly}
            spellCheck={spellCheck}
            value={inputFieldValue}
            type={fieldType}
            onChange={event => onChange(event.target.value)}
            onFocus={onFocus}
            onKeyUp={this.onKeyUp}
            onBlur={onBlur}
            disabled={disabled}
            onKeyDown={onKeyDown}
            required
          />
          {label}
          {severity === ERROR && (
            <img className="error-icon" src={inputErrorSrc} />
          )}
        </div>
        <span className="input-status">{status}</span>
      </div>
    );
  }

  onKeyUp(e) {
    if (e.keyCode === ENTER && this.props.onEnter) {
      this.props.onEnter(e);
    }
  }
}
